import {Component, OnInit} from '@angular/core';
import {BaseComponent, CommonService, Shared, UserService} from "@rubii/frontend-common";
import {ConfigService} from "../../services/config.service";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ActivatedRoute} from '@angular/router';
import {DomSanitizer} from "@angular/platform-browser";
import {ItemResponse} from "@rubii/frontend-common/lib/models/common/Response";
import { HttpClient } from '@angular/common/http';
import { ClientService } from '../../services/client.service';
import { HttpException } from '@rubii/share/src/classes';

@Component({
    selector: 'app-tenant-setting',
    templateUrl: './tenant.component.html',
    styleUrls: ['./tenant.component.scss']
})
export class TenantComponent extends BaseComponent implements OnInit {


    shared = Shared;
    fileUpload: File;
    previewURL = 'assets/images/camera.svg';

    constructor(private config: ConfigService, private http: HttpClient, private userService: UserService, private client: ClientService, private snack: MatSnackBar, private dialog: MatDialog,
                private activatedRoute: ActivatedRoute, public domSanitizer: DomSanitizer) {
        super();
    }

    async ngOnInit() {
        this.client.tenant.getLogo().then(link => this.previewURL = link || 'assets/images/camera.svg');   
    }

    fileChange(event) {
        this.fileUpload = event.target.files[0];
        this.previewURL = URL.createObjectURL(this.fileUpload);
    }

    save() {
        if(this.fileUpload) {
            const reader: FileReader = new FileReader();
            reader.readAsDataURL(this.fileUpload);
            reader.onload = async () => {
                const data = {
                    value: (reader.result as string).split(',')[1],
                    fileName: this.fileUpload.name,
                    fileType: this.fileUpload.type,
                    type: 'image' as 'image' | 'font',
                    advertiserId: undefined,
                };
                try {
                    this.previewURL = await this.client.tenant.uploadLogo(data);
                    this.openSnackBar(this.snack, 'Logo is updated.', 'close');
                } catch (e) {
                    const error = e as HttpException;
                    this.openSnackBarWarning(this.snack, error.message, 'close');
                }
            };
        } else {
            this.openSnackBarWarning(this.snack, 'Please select an image.', 'close');
        }
    }
}
